import { EndpointRequest } from "../../_system/EndpointRequest";
import {
  ReservationReadRequestDto as RequestDto,
  ReservationReadResponseDto as ResponseDto,
} from "../../api/reservation/read/dtos";
import { Api } from "../../api";

export const read = new EndpointRequest<RequestDto, ResponseDto>(
  "READ_RESERVATION",
  Api.reservation.read
);
